import { Product } from '../swagger';

/**
 * The states a health checkup can be bought again from. A one-time checkup is
 * COMPLETED the moment it is paid, so "done" is the normal state to buy again
 * from; cancelled is the other. The engine has the final say — it also refuses
 * one still inside its paid period.
 */
export const isRecreateCandidate = (status?: Product.StatusEnum): boolean =>
  status === Product.StatusEnum.Cancelled ||
  status === Product.StatusEnum.Completed;
